module.exports = __webpack_public_path__ + "media/images/arrow-left-black-5927354768906e27c71e19e91236ab3e.png";